Alpine.data('alpine_notice', () => ({
  show: false,

  checkCookie(cookieKey) {
    let cookieName = 'MFnotice' + cookieKey + '=';

    if(!document.cookie.split('; ').find(row => row.startsWith(cookieName))) {
      this.show = true;
    }
  },

  closeAndCookie(cookieKey, expiration) {
    this.show = false;

    this.setCookie('MFnotice' + cookieKey, expiration, true);

    setTimeout(() => {
      this.$el.remove();
    }, 1000);
  },

  setCookie(name, expiration, value) {
    let expireDate = new Date(expiration + ' 12:00:00').toUTCString();

    document.cookie = name + '=' + (value || '') + '; '
      + 'expires=' + expireDate + '; '
      + "SameSite=Lax; "
      + "Secure";
  },
}));
